import Skeleton from '@mui/material/Skeleton';
import { StyledSkeletonTable } from 'pages/Monitoring/OrderProviderExternalErrors/OrderProviderExternalErrorsSummary/OrderProviderExternalErrorsSummary.styled';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TableBody, TableCell, TableCellHeader, TableHead, TableRow } from 'shared/mui/Table';

export const OrderProviderExternalErrorsSummaryDialogSkeleton: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <StyledSkeletonTable>
      <TableHead>
        <TableRow>
          <TableCellHeader label={translate('app.table.provider')} />
          <TableCellHeader label={translate('app.table.gateway')} />
          <TableCellHeader
            label={translate('app.orderProviderExternalErrors.datagrid.numberOfDeclines')}
          />
          <TableCellHeader
            label={translate('app.orderProviderExternalErrors.datagrid.percentOfDeclines')}
          />
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: 5 }).map((_, index) => (
          <TableRow key={index}>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledSkeletonTable>
  );
};
